"use client";

import { BookOpen, Compass, Users } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Ergonomische Plätze",
  description: "Bequem sitzen, produktiv arbeiten.",
  icon: Compass
}, {
  title: "Highspeed-WLAN",
  description: "Schnelles Internet ohne Unterbrechungen.",
  icon: Users
}, {
  title: "Küchen-Flatrate",
  description: "Kaffee, Tee und Gemeinschaft.",
  icon: BookOpen
}];
export default function InfoColumns() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}